import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: {
	events: { key: string; value: string; type: string }[];
	subscribedEventsType: string[];
} = {
	events: [],
	subscribedEventsType: [],
};

const sseEventsSlice = createSlice({
	name: 'sseEvents',
	initialState,
	reducers: {
		addEventSubscription: (state, { payload }: PayloadAction<string>) => {
			state.subscribedEventsType = [payload, ...state.subscribedEventsType];
		},
		removeEventSubscription: (state, { payload }: PayloadAction<string>) => {
			state.subscribedEventsType = [
				...state.subscribedEventsType.filter(el => el !== payload),
			];
			state.events = [...state.events.filter(el => el.type !== payload)];
		},
		addSseMessage: (
			state,
			{ payload }: PayloadAction<{ key: string; value: string; type: string }>,
		) => {
			if (state.subscribedEventsType.includes(payload.type)) {
				state.events = [payload, ...state.events];
				if (state.events.length > 500) state.events.pop();
			}
		},
		removeSseMessage: (
			state,
			{ payload }: PayloadAction<{ key: string; value: string; type: string }>,
		) => {
			state.events = [
				...state.events.filter(
					el => !(el.key === payload.key && el.type === payload.type),
				),
			];
		},
	},
});

export const {
	addEventSubscription,
	removeEventSubscription,
	addSseMessage,
	removeSseMessage,
} = sseEventsSlice.actions;

export default sseEventsSlice.reducer;
